import { Component, Input, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { UnreadReportsService } from "../../services/unread-reports/unread-reports.service";
import { Subscription } from "rxjs";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { ComponentModule } from "../component.module";

@Component({
    standalone: true,
    imports: [IonicModule, TranslateModule, ComponentModule],
    selector: "app-document-navigation-modal",
    templateUrl: "./document-navigation-modal.component.html",
    styleUrls: ["./document-navigation-modal.component.scss"]
})
export class DocumentNavigationModalComponent implements OnInit, OnDestroy {
    @Input() callback: any;

    public unreadCount: number = 0;
    private subscription: Subscription;

    constructor(
        private router: Router,
        private unreadReportsService: UnreadReportsService
    ) {}

    ngOnInit() {
        this.subscription =
            this.unreadReportsService.unreadReportsState$.subscribe(
                ({ count }) => {
                    this.unreadCount = count;
                }
            );
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    navigateTo(link: string) {
        this.callback("close");
        this.router.navigate([link]);
    }
}
